import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { PropagateLoader } from 'react-spinners';
import image from '../image/i.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState(localStorage.getItem('email') || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const sanitizeIdentityValue = (value) => {
    const text = String(value ?? '').trim();
    if (!text) return '';
    const lowered = text.toLowerCase();
    return lowered === 'undefined' || lowered === 'null' ? '' : text;
  };

  const extractHouseId = (user = {}) => {
    const candidates = [
      user.houseId,
      user.house_id?._id,
      user.house_id?.id,
      user.house_id,
    ];

    const valid = candidates.find((value) => {
      if (!value) return false;
      if (typeof value !== 'string') return true;
      const trimmed = value.trim();
      return trimmed !== '' && trimmed !== 'undefined' && trimmed !== '[object Object]';
    });

    return typeof valid === 'string' ? valid.trim() : (valid || '');
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    const showAuto = localStorage.getItem('showAutoLogoutToast');
    if (showAuto === 'true') {
      toast.info('You have been logged out due to inactivity');
      localStorage.removeItem('showAutoLogoutToast');
    }
  }, []);

  const handleLogin = async () => {
    setLoading(true);
    setError('');

    try {
      const { data, error } = await login(email, password);
      setLoading(false);

      if (data) {
        if (rememberMe) {
          localStorage.setItem('email', email);
        } else {
          localStorage.removeItem('email');
        }

        console.log('═══════════════════════════════════════');
        console.log('✅ LOGIN SUCCESSFUL');
        console.log('═══════════════════════════════════════');
        console.log('📋 Full Login Response:', data);
        console.log('👤 User object:', data.user);
        console.log('🏠 data.user.houseId:', data.user.houseId);
        console.log('🏠 data.user.house_id:', data.user.house_id);
        
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('role', data.role);
        localStorage.setItem('user_id', data.user._id);
        localStorage.setItem('house_id', extractHouseId(data.user));
        localStorage.setItem('estate_id', data.user.estate_id || '');
        localStorage.setItem('firstname', sanitizeIdentityValue(data.user.firstname));
        localStorage.setItem('title', sanitizeIdentityValue(data.user.title));

        console.log('💾 STORED IN LOCALSTORAGE:');
        console.log('  user_id:', localStorage.getItem('user_id'));
        console.log('  house_id:', localStorage.getItem('house_id'));
        console.log('  role:', localStorage.getItem('role'));
        console.log('═══════════════════════════════════════');

        // show welcome toast then navigate after a short delay
            // mark to show welcome toast on the dashboard after navigation
            localStorage.setItem('showWelcomeToast', 'true');

        const destination = data.role === 'SUPER ADMIN'
          ? '/superAdmin'
          : data.role === 'ADMIN'
            ? '/Hub'
            : data.role === 'SECURITY'
              ? '/security-dashboard'
              : '/dashboard';

        setEmail('');
        setPassword('');

        setTimeout(() => {
          navigate(destination);
        }, 1400);
      } else {
        const msg = error || 'Wrong password or email';
        setError(msg);
        toast.error(msg);
      }
    } catch (error) {
      setLoading(false);
      const msg = error?.response?.data?.message || error?.message || 'An error occurred. Please try again.';
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <div className="lp-wrapper">
      {/* Left branded panel */}
      <div className="lp-left">
        <div className="lp-left-content">
          <div className="lp-logo-wrap">
            <img src={image} alt="Logo" />
          </div>
          <h2 className="lp-brand-title">Estate Management</h2>
          <p className="lp-brand-sub">
            Manage residents, payments, reports and more — all in one place.
          </p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="lp-right">
        <div className="lp-card">
          {/* Logo shown only on mobile when lp-left is hidden */}
          <div className="lp-mobile-logo">
            <img src={image} alt="Logo" />
          </div>

          <h3 className="lp-title">Welcome Back</h3>
          <p className="lp-subtitle">Sign in to your account to continue</p>

          <div className="lp-field">
            <label className="lp-label">Email Address</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="lp-input"
              placeholder="you@example.com"
            />
          </div>

          <div className="lp-field">
            <label className="lp-label">Password</label>
            <div className="lp-input-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="lp-input"
                placeholder="Enter your password"
              />
              <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye}
                className="lp-eye"
                onClick={togglePasswordVisibility}
              />
            </div>
          </div>

          <div className="lp-options">
            <label className="lp-remember">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span>Remember Me</span>
            </label>
            <Link className="lp-forgot" to="/forgot-password">
              Forgot Password?
            </Link>
          </div>

          <button
            onClick={handleLogin}
            className="lp-submit"
            type="button"
            disabled={loading}
          >
            {loading ? (
              <span className="lp-loading">
                Processing&nbsp;&nbsp;
                <PropagateLoader color="#fff" size={7} loading={true} />
              </span>
            ) : (
              'Sign In'
            )}
          </button>

          {error && <p className="lp-error">{error}</p>}
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default Login;
